(ns app.front.dashboard.code-enforcement
  (:require [app.domain.group.permit-type-config.model :as ptc-model]
            [app.front.dashboard.common :as dashboard-common]
            [app.front.entities :as entities]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.front.session :as session]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::queue-fetch-open-complaint-total
  (fn [{:keys [db]} _]
    (if (:session/user db)
      {:dispatch [::fetch-open-complaint-total]}
      {:async-flow {:rules [{:when     :seen-any-of?
                             :events   [::session/restored-session]
                             :dispatch [::fetch-open-complaint-total]
                             :halt?    true}]}})))


(rf/reg-event-fx ::fetch-open-complaint-total
  (fn [{:keys [db]} _]
    ;; Might not be bulletproof, but good enough, this just returns 0 if caller for non-CE people.
    (when (->> db
               ::entities/entity-db
               vals
               (some #(-> % :scope/permit-type ptc-model/permit-types-with-complaints)))
      {:comm/command {:command    :complaint/open-complaint-total
                      :method     :get
                      :on-success [::fetch-open-complaint-total.success]}})))


(rf/reg-event-db ::fetch-open-complaint-total.success
  (fn [db [_ _ {:keys [total]}]]
    (assoc db ::open-complaint-total total)))


(rf/reg-sub ::open-complaint-total
  :-> ::open-complaint-total)


(defn dashboard-section [tr code-enforcement? work-orders?]
  (let [total (<sub [::open-complaint-total])]
    [:section.dashlet
     [:h2 (tr [(if (ff/enabled? :feature-flag.id/ce-and-pwo-translations)
                 :code-enforcement/complaints
                 :code-enforcement/code-enforcement)])]
     [dashboard-common/link-box-container {:class "justify-between"}
      [dashboard-common/link-box-with-number {:title    (tr [:code-enforcement/open-complaints])
                                              :href     (href/href :view/code-enforcement-complaints)
                                              :loading? (nil? total)}
       total]
      [:div.flex.w-full.md:w-1-2.lg:w-1-3.px-2.mt-3.justify-end.gap-2
       (when code-enforcement? (cc/button {:icon i/arrow-right
                                           :href (href/href :view/code-enforcement-complaints)
                                           :kind :tertiary}
                                          (tr [:code-enforcement/create-new-case])))
       (when work-orders? (cc/button {:icon i/arrow-right
                                      :href (href/href :view/code-enforcement-complaints)
                                      :kind :tertiary}
                                     (tr [:work-orders/create-work-order])))]]]))
